export var InteractionEventType;
(function (InteractionEventType) {
    InteractionEventType["crossover"] = "crossover";
})(InteractionEventType || (InteractionEventType = {}));
export var LevelInteractionRole;
(function (LevelInteractionRole) {
    LevelInteractionRole["onTop"] = "onTop";
    LevelInteractionRole["onBottom"] = "onBottom";
})(LevelInteractionRole || (LevelInteractionRole = {}));
//# sourceMappingURL=LevelInteractions.js.map